import { RouteMetadata } from './types';

export const appsMetadata: RouteMetadata[] = [
    {
        pattern: '/agents/:agentId/apps/:appSlug/*',
        section: 'apps',
        view: 'detail',
        descriptionTemplate: 'User is viewing {appSlug} for organization {agentId}',
        capabilities: [
            'Open the selected organization micro app',
            'Install, enable, disable, and retry the selected installation',
        ],
        hints: ['Apps is in the organization sidebar under Integrations'],
    },
    {
        pattern: '/agents/:agentId/apps/:appSlug',
        section: 'apps',
        view: 'detail',
        descriptionTemplate: 'User is viewing {appSlug} for organization {agentId}',
        capabilities: [
            'Open the selected organization micro app',
            'Install, enable, disable, and retry the selected installation',
        ],
        hints: ['Apps is in the organization sidebar under Integrations'],
    },
    {
        pattern: '/agents/:agentId/apps',
        section: 'apps',
        view: 'list',
        descriptionTemplate: 'User is viewing organization micro apps for {agentId}',
        capabilities: [
            'Browse compiled micro apps for this organization',
            'Select an app to open its workspace or manage the installation',
        ],
        hints: ['Apps is in the organization sidebar under Integrations'],
    },
];
